export default __webpack_public_path__ + "assets/e4f76ef268bbcb098a3dbe86e0b09bd9.jpeg";